export default __webpack_public_path__ + "static/media/monoful-logo-background-white.36a3cb6c.svg";